/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountingRequest {
    /** @format date-time */
    startDate?: string;
    /** @format date-time */
    endDate?: string;
}

export interface ActiveCreateParams {
    request?: BuyerActiveApiRequest;
}

export interface BiddingCreateParams {
    request?: BuyerBiddingApiRequest;
}

export interface BookedShipmentGetByCheckoutIdRequest {
    /** @format uuid */
    shipmentCheckoutId?: string;
}

export interface BookedShipmentGetByPurchaseOrderIdRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface BoughtPageCreateParams {
    request?: BoughtPageApiRequest;
}

export interface BoughtpurchaseorderRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface BoughtpurchaseordersCreateParams {
    request?: BuyerBoughtPurchaseOrdersApiRequest;
}

export interface BoughtpurchaseordersincludingextendedlifeCreateParams {
    request?: BuyerBoughtPurchaseOrdersIncludingExtendedLifeApiRequest;
}

export interface CanceldiscountCreateParams {
    request?: CancelDiscountApiRequest;
}

export interface CanceldiscountpaymentattemptCreateParams {
    request?: CancelDiscountPaymentAttemptApiRequest;
}

export interface CancelinvoicepaymentattemptCreateParams {
    request?: CancelInvoicePaymentAttemptApiRequest;
}

export interface CancelshipmentCreateParams {
    request?: CancelShipmentApiRequest;
}

export interface CancelshipmentpaymentattemptCreateParams {
    request?: CancelShipmentPaymentAttemptApiRequest;
}

export interface ChangecombinedshippingviewmodelRequest {
    request?: GetChangeCombinedShippingViewModelApiRequest;
}

export interface CombinedLabelDetailParams {
    rotate?: boolean;
    checkoutId: string;
}

export interface CreateshipmentcheckoutCreateParams {
    request?: CreateShipmentCheckoutV2ApiRequest;
}

export interface DeleteshipmentCreateParams {
    request?: DeleteShipmentApiRequest;
}

export interface DetailsRequest {
    /** @format int32 */
    sequenceNumber?: number;
}

export interface DiscountattemptCreateParams {
    request?: InitializeDiscountAttemptApiRequest;
}

export interface DiscountbraintreeclienttokenRequest {
    paymentMethod?: string;
}

export interface DiscountpaymentoptionsRequest {
    request?: GetDiscountPaymentOptionsApiRequest;
}

export interface GeneratespecificationCreateParams {
    request?: Dac7GenerateSpecificationApiRequest;
}

export interface GetShippingComplaintDataRequest {
    /** @format uuid */
    shipmentId?: string;
}

export interface GetWalletParams {
    eventTypes?: string[];
    /** @format date-time */
    startDate?: string;
    /** @format date-time */
    endDate?: string;
    /** @format int32 */
    toSequenceNumber?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface GetagentsRequest {
    zipCode?: string;
    shippingProviderId?: string;
    countryCodeIso2?: string;
    street?: string;
}

export interface GetshipmentreceiptRequest {
    /** @format uuid */
    shipmentCheckoutId?: string;
}

export interface GetshipmentsbycheckoutidRequest {
    /** @format uuid */
    shipmentCheckoutId?: string;
}

export interface GetspecificationurlRequest {
    /** @format int32 */
    year?: number;
    fileName?: string;
}

export interface ImageUploadUrlCreateParams {
    request?: CreateShippingComplaintImageUploadUrlApiRequest;
}

export interface InitializediscountpaymentattemptCreateParams {
    request?: InitializeDiscountPaymentAttemptApiRequest;
}

export interface InitializeinvoicepaymentattemptCreateParams {
    request?: InitializeInvoicePaymentAttemptApiRequest;
}

export interface InitializeshipmentpaymentattemptCreateParams {
    request?: InitializeShipmentPaymentAttemptApiRequest;
}

export interface InvoicebraintreeclienttokenDetailParams {
    paymentMethod?: string;
    /** @format int64 */
    invoiceId: number;
}

export interface InvoicecheckoutRequest {
    /** @format int64 */
    invoiceId?: number;
}

export interface IsbookingcompleteRequest {
    /** @format uuid */
    shipmentCheckoutId?: string;
}

export interface ListingsCreateParams {
    request?: SellerListingsApiRequest;
}

export interface LostCreateParams {
    request?: BuyerLostApiRequest;
}

export interface ManualpayoutCreateParams {
    request?: PerformManualPayoutApiRequest;
}

export interface ManualpayoutRequest {
    /** @format uuid */
    payoutAttemptId?: string;
}

export interface OrderInfoRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface OrderInfoPdfCreateParams {
    request?: CreateOrderInfoPdfApiRequest;
}

export interface OrderInfoPdfRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface OutstandingActionsBuyerRequest {
    request?: OutstandingBuyerActionsApiRequest;
}

export interface OutstandingActionsSellerRequest {
    request?: OutstandingSellerActionsApiRequest;
}

export interface OverviewRequest {
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
}

export interface PayoutdetailsRequest {
    sequenceNumbers?: number[];
}

export interface PayoutstatusRequest {
    request?: PayoutStatusApiRequest;
}

export interface PayoutsviewstatusCreateParams {
    request?: PayoutsViewStatusApiRequest;
}

export interface PendingRequest {
    request?: WalletPendingApiRequest;
}

export interface PendingdetailsRequest {
    /** @format int32 */
    orderNumber?: number;
}

export interface PurchaseOrderRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface PurchaseOrdersRequest {
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface PurchasesCreateParams {
    request?: BuyerPurchaseApiRequest;
}

export interface RefundcheckoutRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface ResellSuggestionsRequest {
    languageCodeIso2?: string;
    automaticTranslationPreferred?: boolean;
    /** @format int32 */
    take?: number;
}

export interface SaveShippingComplaintDataCreateParams {
    request?: SaveShippingComplaintDataApiRequest;
}

export interface SellerStatsOverviewRequest {
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
}

export interface SellerstatsRequest {
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
}

export interface ShipmentCreateParams {
    request?: SaveShippingDetailsV2ApiRequest;
}

export interface ShipmentRequest {
    shipmentId?: string;
}

export interface ShipmentbraintreeclienttokenDetailParams {
    paymentMethod?: string;
    /** @format uuid */
    shipmentCheckoutId: string;
}

export interface ShipmentsWithQrCodesToBeShippedRequest {
    /** @format int32 */
    pageIndex?: number;
    /** @format int32 */
    pageSize?: number;
}

export interface SoldCreateParams {
    request?: SellerSoldApiRequest;
}

export interface SoldPageCreateParams {
    request?: SoldPageApiRequest;
}

export interface SoldpurchaseorderRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface SoldpurchaseordersCreateParams {
    request?: SellerSoldPurchaseOrdersApiRequest;
}

export interface SoldpurchaseordersincludingextendedlifeCreateParams {
    request?: SellerSoldPurchaseOrdersIncludingExtendedLifeApiRequest;
}

export interface SummaryRequest {
    /** @format int32 */
    year?: number;
}

export interface SystemBadgesRequest {
    request?: SystemBadgesApiRequest;
}

export interface TraceRequest {
    /** @format uuid */
    shipmentId?: string;
}

export interface ResponseError {
    errorCode?: string | null;
    fieldName?: string | null;
    message?: string | null;
}

export interface ResponseError10 {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface ResponseError2 {
    /** @format int32 */
    skip?: number;
    /** @format int32 */
    take?: number;
}

export interface ResponseError3 {
    request?: SellerActiveApiRequest;
}

export interface ResponseError6 {
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
}

export interface ResponseStatus {
    errorCode?: string | null;
    errors?: ResponseError[] | null;
    message?: string | null;
    stackTrace?: string | null;
}

export interface ItemCardDtoItemCardAttribute {
    name?: string | null;
    values?: string[] | null;
}

export interface ItemCardDtoShippingOption {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface ContactDetailsApiDto {
    countryCodeIso2?: string | null;
    alias?: string | null;
    companyName?: string | null;
    country?: string | null;
    email?: string | null;
    firstName?: string | null;
    fullName?: string | null;
    isCompany: boolean;
    lastName?: string | null;
    /** @format int32 */
    memberId: number;
    organizationNumber?: string | null;
    phoneNumber?: string | null;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
}

export interface BuyerActiveApiRequest {
    parameters?: SearchParameters | null;
}

export interface BuyerActiveApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: BuyerNonTransactionalItemResult | null;
}

export interface BuyerBiddingApiRequest {
    parameters?: SearchParameters | null;
}

export interface BuyerBiddingApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: BuyerNonTransactionalItemResult | null;
}

export interface BuyerBoughtPurchaseOrderApiResponse {
    purchaseOrder?: MyTraderaPurchaseOrderApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface BuyerBoughtPurchaseOrdersApiRequest {
    buyerFilters?: PurchaseOrderBuyerStateFilters | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
}

export interface BuyerBoughtPurchaseOrdersApiResponse {
    purchaseOrders?: MyTraderaPurchaseOrderApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalNumberOfPages: number;
    /** @format int32 */
    totalNumberOfPurchaseOrders: number;
    /** @format int32 */
    trackedHistoryLengthInMonths?: number | null;
}

export interface BuyerBoughtPurchaseOrdersIncludingExtendedLifeApiRequest {
    buyerFilters?: PurchaseOrderBuyerStateFilters | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
}

export interface BuyerBoughtPurchaseOrdersIncludingExtendedLifeApiResponse {
    purchaseOrdersOneOf?: BuyerBoughtPurchaseOrderOneOfApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    totalNumberOfPages: number;
    /** @format int32 */
    totalNumberOfPurchaseOrders: number;
    /** @format int32 */
    trackedHistoryLengthInMonths?: number | null;
}

export interface BuyerLostApiRequest {
    parameters?: SearchParameters | null;
}

export interface BuyerLostApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: BuyerNonTransactionalItemResult | null;
}

export interface BuyerPurchaseApiRequest {
    parameters?: SearchParameters | null;
}

export interface BuyerPurchaseApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: BuyerPurchaseItemResult | null;
}

export interface CompensationData {
    /** @format int32 */
    amount: number;
}

export interface Compensations {
    q1?: CompensationData | null;
    q2?: CompensationData | null;
    q3?: CompensationData | null;
    q4?: CompensationData | null;
    /** @format int32 */
    totalAmount: number;
}

export interface Dac7GenerateSpecificationApiRequest {
    /** @format int32 */
    year: number;
}

export interface Dac7GenerateSpecificationApiResponse {
    responseStatus?: ResponseStatus | null;
    specification?: Specification | null;
}

export interface Dac7GenerateSpecificationUrlApiResponse {
    responseStatus?: ResponseStatus | null;
    url?: string | null;
}

export interface Dac7ReportSummaryApiResponse {
    reportSummary?: ReportSummary | null;
    responseStatus?: ResponseStatus | null;
    specification?: Specification | null;
}

export interface FeeData {
    /** @format int32 */
    amount: number;
}

export interface Fees {
    q1?: FeeData | null;
    q2?: FeeData | null;
    q3?: FeeData | null;
    q4?: FeeData | null;
    /** @format int32 */
    totalAmount: number;
}

export interface ReportSummary {
    compensations?: Compensations | null;
    fees?: Fees | null;
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    reportId: number;
    /** @format int32 */
    year: number;
}

export interface Specification {
    documents?: string[] | null;
    status?: string | null;
}

/** @format int32 */
export enum Aggregations {
    Value1 = 1,
    Value2 = 2,
    Value4 = 4,
    Value8 = 8,
    Value16 = 16,
    Value32 = 32,
}

export enum BoolFilterEnum {
    All = 'All',
    True = 'True',
    False = 'False',
}

export interface BuyerStateFilters {
    feedbackLeft: BoolFilterEnum;
    hidden: BoolFilterEnum;
    paid: BoolFilterEnum;
}

export enum DateField {
    StartDate = 'StartDate',
    EndDate = 'EndDate',
    TransactionDate = 'TransactionDate',
}

export interface DateRangeFilter {
    field: DateField;
    from?: string | null;
    to?: string | null;
}

export enum ItemProcessState {
    All = 'All',
    OnGoing = 'OnGoing',
    Transactions = 'Transactions',
    Ended = 'Ended',
}

export enum InputOrder {
    Ascending = 'Ascending',
    Descending = 'Descending',
}

export interface Paging {
    /** @format int32 */
    skip: number;
    /** @format int32 */
    take: number;
}

/** @format int32 */
export enum PropertiesEnum {
    Value1 = 1,
    Value2 = 2,
    Value4 = 4,
    Value8 = 8,
    Value16 = 16,
    Value32 = 32,
    Value39 = 39,
    Value64 = 64,
    Value81 = 81,
    Value105 = 105,
    Value128 = 128,
    Value255 = 255,
}

export interface PurchaseOrderBuyerStateFilters {
    feedbackLeft: BoolFilterEnum;
    hidden: BoolFilterEnum;
    paid: BoolFilterEnum;
}

export interface PurchaseOrderSellerStateFilters {
    combinedShippingPriceRequested: BoolFilterEnum;
    feedbackLeft: BoolFilterEnum;
    hidden: BoolFilterEnum;
    paid: BoolFilterEnum;
    shipped: BoolFilterEnum;
}

export enum InputPurchaseType {
    All = 'All',
    Auction = 'Auction',
    BuyItNow = 'BuyItNow',
    FixedPrice = 'FixedPrice',
}

export interface Query {
    properties: PropertiesEnum;
    scope: Scope;
    searchQuery?: string | null;
}

export enum Scope {
    And = 'And',
    Or = 'Or',
    Relevance = 'Relevance',
}

export enum SearchItemCondition {
    All = 'All',
    Used = 'Used',
    New = 'New',
}

export enum SearchItemType {
    All = 'All',
    Auction = 'Auction',
    BuyItNow = 'BuyItNow',
    FixedPrice = 'FixedPrice',
}

export interface SearchParameters {
    aggregations?: Aggregations | null;
    /** @format int32 */
    bidderMemberId?: number | null;
    buyerFilters?: BuyerStateFilters | null;
    dateRange?: DateRangeFilter | null;
    hasBids: BoolFilterEnum;
    itemCondition: SearchItemCondition;
    itemType: SearchItemType;
    paging?: Paging | null;
    processState: ItemProcessState;
    purchaseType: InputPurchaseType;
    query?: Query | null;
    reservePriceReached: BoolFilterEnum;
    sellerFilters?: SellerStateFilters | null;
    sort?: Sort | null;
}

export interface SellerStateFilters {
    feedbackLeft: BoolFilterEnum;
    hidden: BoolFilterEnum;
    paid: BoolFilterEnum;
    shipped: BoolFilterEnum;
    shippingBooked: BoolFilterEnum;
}

export interface Sort {
    order: InputOrder;
    sorting: Sorting;
}

export enum Sorting {
    EndDate = 'EndDate',
    BuyerAlias = 'BuyerAlias',
    SellerAlias = 'SellerAlias',
    TransactionDate = 'TransactionDate',
    Price = 'Price',
    OwnReference = 'OwnReference',
    OpeningBid = 'OpeningBid',
    NumberOfBids = 'NumberOfBids',
    ItemId = 'ItemId',
    ShortDescription = 'ShortDescription',
    BestMatch = 'BestMatch',
}

export enum ActivityType {
    NotPublished = 'NotPublished',
    Active = 'Active',
    Sold = 'Sold',
    Unsold = 'Unsold',
}

export interface OutputAddress {
    countryCodeIso2?: string | null;
    city?: string | null;
    country?: string | null;
    street?: string | null;
    zipCode?: string | null;
}

export interface BidInformation {
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    leadingBidAmount?: number | null;
    leadingBidder?: PublicMember | null;
    /** @format int32 */
    nextValidBidAmount: number;
}

export interface BookedShipment {
    hasShipmentLabel: boolean;
    hasShipmentReceipt: boolean;
    /** @format uuid */
    id: string;
    isSoldByTradera: boolean;
    labellessShippingCode?: string | null;
    qrCodeImageStatus?: string | null;
    qrCodeImageUrl?: string | null;
}

export interface BuyerBoughtExtendedLifePurchaseOrderApiDto {
    buyer?: ExtendedLifeMember | null;
    /** @format date-time */
    createdDate: string;
    /** @format int32 */
    orderNumber: number;
    payment?: BuyerBoughtPurchaseOrderPaymentApiDto | null;
    /** @format uuid */
    purchaseOrderId: string;
    rows?: BuyerBoughtExtendedLifePurchaseOrderRowApiDto[] | null;
    seller?: ExtendedLifeMember | null;
}

export interface BuyerBoughtExtendedLifePurchaseOrderRowApiDto {
    /** @format int32 */
    bidCount?: number | null;
    /** @format date-time */
    endDate: string;
    isResellPossible: boolean;
    /** @format double */
    itemPrice: number;
    itemType?: string | null;
    mainImageTemplate?: string | null;
    /** @format int32 */
    objectNumber: number;
    shortDescription?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface BuyerBoughtPurchaseOrderOneOfApiDto {
    extendedLifePurchaseOrder?: BuyerBoughtExtendedLifePurchaseOrderApiDto | null;
    purchaseOrder?: MyTraderaPurchaseOrderApiDto | null;
}

export interface BuyerBoughtPurchaseOrderPaymentApiDto {
    paymentMethodExchangeRate?: ExchangeRateApiDto | null;
}

export interface BuyerInitialPricing {
    /** @format int32 */
    buyItNow?: number | null;
    /** @format int32 */
    discountRate?: number | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    vat?: number | null;
}

export interface BuyerItem {
    activityType: ActivityType;
    bidInformation?: BidInformation | null;
    caller?: Caller | null;
    /** @format int32 */
    currentPrice?: number | null;
    /** @format double */
    finalPrice?: number | null;
    forciblyClosed?: ForciblyClosed | null;
    isActive: boolean;
    isArchived: boolean;
    /** @format int32 */
    itemId: number;
    itemUrl?: string | null;
    listing?: BuyerListingProperties | null;
    reservePriceReached: boolean;
    seller?: Member | null;
    transaction?: BuyerTransactionData | null;
}

export interface BuyerListingProperties {
    allowedBuyerRegion?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId: number;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    endDate?: FormattedDate | null;
    images?: Images | null;
    itemCondition: ItemCondition;
    itemIsOnDisplay: boolean;
    itemType: ItemType;
    paymentOptions?: string[] | null;
    pricing?: BuyerInitialPricing | null;
    /** @format int32 */
    quantity?: number | null;
    restart?: RestartMetadata | null;
    shippingOptions?: OutputShippingOption[] | null;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingTerms?: string | null;
    shortDescription?: string | null;
    startDate?: FormattedDate | null;
    timeLeft?: TimeLeft | null;
}

export interface BuyerNonTransactionalItemResult {
    /** @format int32 */
    currentMemberId?: number | null;
    /** @format date-time */
    currentTime: string;
    items?: BuyerItem[] | null;
    paging?: PagingResult | null;
    searchParameters?: SearchParameters | null;
}

export interface BuyerPurchaseItemResult {
    /** @format int32 */
    currentMemberId?: number | null;
    /** @format date-time */
    currentTime: string;
    items?: BuyerItem[] | null;
    paging?: PagingResult | null;
    searchParameters?: SearchParameters | null;
}

export interface BuyerPurchaseOrderForLeaveFeedbackDto {
    hasBuyerProtection: boolean;
    hasRegisteredDispute: boolean;
    hasRegisteredInr: boolean;
    isPaid: boolean;
    /** @format uuid */
    purchaseOrderId: string;
    sellerAlias?: string | null;
    /** @format int32 */
    sellerMemberId: number;
    showDisputeAlertBoxOnNegativeReview: boolean;
    transactions?: BuyerTransactionForLeaveFeedbackDto[] | null;
}

export interface BuyerState {
    feedbackLeft: boolean;
    hidden: boolean;
    inr: boolean;
    paid: boolean;
}

export interface BuyerStateApiDto {
    feedbackLeft: boolean;
    isInrSubmitted: boolean;
}

export interface BuyerTransactionData {
    disputeV2?: DisputeV2 | null;
    buyer?: Member | null;
    buyerState?: BuyerState | null;
    discounts?: Discount[] | null;
    dispute?: Dispute | null;
    hasBuyerProtection: boolean;
    isDiscountAfterPaymentSupported: boolean;
    isDiscountBeforePaymentSupported: boolean;
    isPaidWithIntegratedPaymentOption: boolean;
    isPaymentExpired: boolean;
    isPaynovaPayment: boolean;
    /** @format int32 */
    orderNumber?: number | null;
    /** @format uuid */
    paidShipmentCheckoutId?: string | null;
    paidStatus?: string | null;
    /** @format int32 */
    price: number;
    /** @format uuid */
    purchaseOrderId?: string | null;
    selectedShipping?: SelectedShipping | null;
    /** @format uuid */
    shipmentId?: string | null;
    /** @deprecated */
    shippingDiscount?: ShippingDiscount | null;
    trackingLink?: string | null;
    transactionDate?: FormattedDate | null;
    /** @format int32 */
    transactionId: number;
}

export interface BuyerTransactionForLeaveFeedbackDto {
    imageUrl?: string | null;
    itemUrl?: string | null;
    reportDisputeUrl?: string | null;
    shortDescription?: string | null;
    /** @format date-time */
    transactionDate: string;
    /** @format int32 */
    transactionId: number;
}

export interface BuyingApiDto {
    /** @format int32 */
    bidCount: number;
}

export interface Caller {
    hidden: boolean;
    leadingBidRemoved: boolean;
    /** @format int32 */
    maxBid?: number | null;
}

export interface CombinedShippingInformationApiDto {
    /** @format date-time */
    buyerRequestedCombinedShippingPriceDate?: string | null;
    /** @format int32 */
    combinedShippingDays: number;
    /** @format int32 */
    days: number;
    /** @format int32 */
    daysAfterBuyerRequestedCombinedShippingPrice?: number | null;
    /** @format int32 */
    daysAfterSellerSetCombinedShippingPrice?: number | null;
    /** @format int32 */
    daysLeft: number;
    /** @format int32 */
    daysUntilPurchaseOrderExpires?: number | null;
    /** @format date-time */
    expiresDate: string;
    hasBuyerRequestedCombinedShippingPrice: boolean;
    /** @format date-time */
    purchaseOrderExpiresDate?: string | null;
    /** @format date-time */
    sellerSetCombinedShippingPriceDate?: string | null;
}

export interface Discount {
    /** @format double */
    amount: number;
    /** @format date-time */
    created: string;
    type?: string | null;
}

export interface DiscountApiDto {
    /** @format double */
    amount: number;
    /** @format date-time */
    createdDate: string;
    /** @format int32 */
    id: number;
}

export interface Dispute {
    /** @format int32 */
    buyerMemberId: number;
    /** @format int32 */
    disputeId?: number | null;
    reason: DisputeReason;
    status: DisputeStatus;
    /** @format date-time */
    timeStamp: string;
}

export interface DisputeV2 {
    /** @format int32 */
    buyerMemberId: number;
    /** @format int32 */
    disputeId: number;
    reason?: string | null;
    /** @format int32 */
    sellerMemberId: number;
    status?: string | null;
    /** @format date-time */
    timeStamp: string;
}

export enum DisputeReason {
    INR = 'INR',
    SNAD = 'SNAD',
    PSNAD = 'PSNAD',
}

export enum DisputeStatus {
    New = 'New',
    WaitingForSeller = 'WaitingForSeller',
    TraderaIsInvestigating = 'TraderaIsInvestigating',
    ToBeClosed = 'ToBeClosed',
    WaitingForBuyer = 'WaitingForBuyer',
    BuyerWonDispute = 'BuyerWonDispute',
    SellerWonDispute = 'SellerWonDispute',
    WaitingForReturn = 'WaitingForReturn',
    Appealed = 'Appealed',
    AvslutadUnder120Kr = 'AvslutadUnder120Kr',
    NotEscalated = 'NotEscalated',
    BuyerMarkedAsSolved = 'BuyerMarkedAsSolved',
    AvailableForPickupTradera = 'AvailableForPickupTradera',
    AvailableForPickupSeller = 'AvailableForPickupSeller',
    WaitingForKlarnaOrPayPal = 'WaitingForKlarnaOrPayPal',
    TheOffice = 'TheOffice',
    Other = 'Other',
    RefundedByTradera = 'RefundedByTradera',
}

export interface ExchangeRateApiDto {
    currencyCode?: string | null;
    /** @format double */
    rate: number;
}

export interface ExtendedLifeMember {
    alias?: string | null;
    /** @format int32 */
    memberId: number;
}

export interface ForciblyClosed {
    closed: boolean;
    /** @format int32 */
    reasonId: number;
}

export interface FormattedDate {
    critical: boolean;
    /** @format date-time */
    date: string;
    formatted?: string | null;
    full?: string | null;
}

export interface Image {
    full?: string | null;
    medium?: string | null;
}

export interface ImageApiDto {
    full?: string | null;
    medium?: string | null;
    multiThumbnail?: string | null;
}

export interface Images {
    main?: Image | null;
    mainTemplate?: string | null;
}

export interface ImagesApiDto {
    main?: ImageApiDto | null;
    mainTemplate?: string | null;
}

export enum ItemCondition {
    None = 'None',
    New = 'New',
    Used = 'Used',
}

export enum ItemType {
    Auction = 'Auction',
    AuctionBin = 'AuctionBin',
    PureBin = 'PureBin',
    Shopitem = 'Shopitem',
}

export interface ListingApiDto {
    allowedBuyerRegion?: string | null;
    /** @format date-time */
    endDate: string;
    images?: ImagesApiDto | null;
    /** @format int32 */
    itemId: number;
    itemResellPublished: boolean;
    itemType?: string | null;
    itemUrl?: string | null;
    ownReference?: string | null;
    paymentOptions?: string[] | null;
    pricing?: PricingApiDto | null;
    shippingOptions?: ShippingOptionApiDto[] | null;
    shortDescription?: string | null;
    /** @format date-time */
    startDate: string;
}

export interface Member {
    address?: OutputAddress | null;
    alias?: string | null;
    email?: string | null;
    facebookId?: string | null;
    /** @format int32 */
    id: number;
    name?: string | null;
    phoneNumber?: string | null;
    /** @format int32 */
    totalRating: number;
}

export interface MyTraderaAddressApiDto {
    countryCodeIso2?: string | null;
    city?: string | null;
    country?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
}

export interface MyTraderaMemberApiDto {
    address?: MyTraderaAddressApiDto | null;
    alias?: string | null;
    city?: string | null;
    cleanedAlias?: string | null;
    emailAddress?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    /** @format int32 */
    memberId: number;
    phoneNumber?: string | null;
    /** @format int32 */
    totalRating: number;
}

export interface MyTraderaPurchaseOrderApiDto {
    buyerMember?: MyTraderaMemberApiDto | null;
    /** @format double */
    buyerProtectionAmount?: number | null;
    combinedShippingInformation?: CombinedShippingInformationApiDto | null;
    /** @format date-time */
    createdDate: string;
    discounts?: DiscountApiDto[] | null;
    isBuyerProtectionMandatory: boolean;
    /** @format int32 */
    orderNumber: number;
    payment?: PaymentApiDto | null;
    /** @format uuid */
    purchaseOrderId: string;
    reportProblemWithPurchaseLink?: string | null;
    rows?: MyTraderaPurchaseOrderRowApiDto[] | null;
    sellerMember?: MyTraderaMemberApiDto | null;
    shipping?: ShippingApiDto | null;
    /** @format double */
    shippingAmount?: number | null;
    shippingFeeRule?: ShippingFeeRuleApiDto | null;
    state?: PurchaseOrderStateApiDto | null;
    /** @format double */
    totalAmount?: number | null;
    /** @format double */
    totalDiscountAmount: number;
    /** @format double */
    totalItemAmount: number;
}

export interface MyTraderaPurchaseOrderRowApiDto {
    buying?: BuyingApiDto | null;
    listing?: ListingApiDto | null;
    transaction?: TransactionApiDto | null;
}

export interface OutstandingBuyerActions {
    /** @format int64 */
    notLeftFeedbackCount: number;
    /** @format int64 */
    notPaidCount: number;
    /** @format int64 */
    outbiddedCount: number;
    /** @format int64 */
    paidNotLeftFeedbackCount: number;
}

export interface OutstandingSellerActions {
    /** @format int64 */
    enterCombinedShippingCount: number;
    /** @format int64 */
    notLeftFeedbackCount: number;
    /** @format int64 */
    notPaidCount: number;
    /** @format int64 */
    notShippedCount: number;
}

export interface OverviewStats {
    /** @format int64 */
    activeThisMonthCount: number;
    /** @format int32 */
    freeListingsCount: number;
    /** @format int64 */
    listedThisMonthCount: number;
    /** @format int32 */
    maxFreeListingsPerMonth: number;
    /** @format int64 */
    soldThisMonthCount: number;
    /** @format int64 */
    unsoldThisMonthCount: number;
}

export interface PagingResult {
    /** @format int64 */
    foundItemsCount: number;
    /** @format int32 */
    from: number;
    /** @format int32 */
    page: number;
    /** @format int32 */
    size: number;
    /** @format int64 */
    totalItems: number;
    /** @format int32 */
    totalPages: number;
}

export interface PaymentApiDto {
    /** @format double */
    buyerProtectionAmount?: number | null;
    /** @format double */
    discountCodeAmount?: number | null;
    hasBuyerProtection: boolean;
    /** @format double */
    paymentAmount: number;
    paymentMethod?: string | null;
    /** @format double */
    paymentMethodAmount?: number | null;
    paymentMethodExchangeRate?: ExchangeRateApiDto | null;
}

export interface PreviewListBuyerItem {
    /** @format int64 */
    count: number;
    items?: BuyerItem[] | null;
}

export interface PreviewListSellerItem {
    /** @format int64 */
    count: number;
    items?: SellerItem[] | null;
}

export interface PreviewList {
    /** @format int64 */
    count: number;
    items?: OverviewItemCardModel[] | null;
}

export interface PricingApiDto {
    /** @format double */
    buyItNow?: number | null;
    /** @format double */
    buyerProtectionCost?: number | null;
    /** @format double */
    openingBid?: number | null;
    /** @format double */
    reservePrice?: number | null;
    /** @format int32 */
    vatPercent?: number | null;
}

export interface PublicMember {
    countryCodeIso2?: string | null;
    alias?: string | null;
    /** @format int32 */
    id: number;
    /** @format int32 */
    totalRating: number;
}

export interface PurchaseOrderStateApiDto {
    isStartDisputeV2Allowed: boolean;
    isStartDisputeV2OverDue: boolean;
    hasUnpaidShipping: boolean;
    isDiscountAllowed: boolean;
    isHiddenForBuyer: boolean;
    isHiddenForSeller: boolean;
    isInrSubmitted: boolean;
    isMarkedAsPaidByBuyer: boolean;
    isMcpSubmitted: boolean;
    isPaid: boolean;
    isPaidWithIntegratedPayment: boolean;
    isPaymentExpired: boolean;
    isRefundAllowed: boolean;
    isShipped: boolean;
    isShippingBooked: boolean;
    isUnderAutoPayoutReview: boolean;
    isUnderPayoutReview: boolean;
    isUpiSubmitted: boolean;
    paidStatus?: string | null;
}

export interface RestartMetadata {
    hasRestartedChild: boolean;
    isRestarted: boolean;
    /** @format int32 */
    rootItemId?: number | null;
}

export interface SelectedShipping {
    /** @format int32 */
    cost: number;
    isFreeShipping: boolean;
    isTakeaway: boolean;
    name?: string | null;
    partnerProvider?: string | null;
    /** @format uuid */
    purchaseOrderId: string;
    type?: string | null;
}

export interface SellerInitialPricing {
    /** @format int32 */
    buyItNow?: number | null;
    /** @format int32 */
    discountRate?: number | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    reservePrice?: number | null;
    /** @format int32 */
    vat?: number | null;
}

export interface SellerItem {
    activityType: ActivityType;
    bidInformation?: BidInformation | null;
    /** @format int32 */
    currentPrice?: number | null;
    /** @format double */
    finalPrice?: number | null;
    forciblyClosed?: ForciblyClosed | null;
    hiddenByMember?: number[] | null;
    isActive: boolean;
    isArchived: boolean;
    /** @format int32 */
    itemId: number;
    itemUrl?: string | null;
    listing?: SellerListingProperties | null;
    reservePriceReached: boolean;
    seller?: Member | null;
    transaction?: SellerTransactionData | null;
    /** @format int32 */
    viewsCount?: number | null;
    /** @format int32 */
    wishlistCount?: number | null;
}

export interface SellerListingProperties {
    allowedBuyerRegion?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId: number;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    endDate?: FormattedDate | null;
    /** @format int32 */
    externalId?: number | null;
    images?: Images | null;
    itemCondition: ItemCondition;
    itemIsOnDisplay: boolean;
    itemType: ItemType;
    ownReference?: string | null;
    paymentOptions?: string[] | null;
    pricing?: SellerInitialPricing | null;
    /** @format int32 */
    quantity?: number | null;
    restart?: RestartMetadata | null;
    shippingOptions?: OutputShippingOption[] | null;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingTerms?: string | null;
    shortDescription?: string | null;
    startDate?: FormattedDate | null;
    timeLeft?: TimeLeft | null;
}

export interface SellerNonTransactionalItemResult {
    /** @format int32 */
    currentMemberId?: number | null;
    /** @format date-time */
    currentTime: string;
    items?: SellerItem[] | null;
    paging?: PagingResult | null;
    searchParameters?: SearchParameters | null;
    sellerEmail?: string | null;
    statistics?: Statistics | null;
}

export interface SellerPurchaseOrderForLeaveFeedbackDto {
    buyerAlias?: string | null;
    /** @format int32 */
    buyerMemberId: number;
    isPaid: boolean;
    /** @format uuid */
    purchaseOrderId: string;
    transactions?: SellerTransactionForLeaveFeedbackDto[] | null;
}

export interface SellerSoldExtendedLifePurchaseOrderApiDto {
    buyer?: ExtendedLifeMember | null;
    /** @format date-time */
    createdDate: string;
    /** @format int32 */
    orderNumber: number;
    /** @format uuid */
    purchaseOrderId: string;
    rows?: SellerSoldExtendedLifePurchaseOrderRowApiDto[] | null;
    seller?: ExtendedLifeMember | null;
}

export interface SellerSoldExtendedLifePurchaseOrderRowApiDto {
    /** @format int32 */
    bidCount?: number | null;
    /** @format date-time */
    endDate: string;
    /** @format double */
    itemPrice: number;
    itemType?: string | null;
    mainImageTemplate?: string | null;
    /** @format int32 */
    objectNumber: number;
    ownReference?: string | null;
    shortDescription?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface SellerSoldItemResult {
    /** @format int32 */
    currentMemberId?: number | null;
    /** @format date-time */
    currentTime: string;
    items?: SellerItem[] | null;
    paging?: PagingResult | null;
    searchParameters?: SearchParameters | null;
    sellerEmail?: string | null;
    statistics?: Statistics | null;
}

export interface SellerSoldPurchaseOrderOneOfApiDto {
    extendedLifePurchaseOrder?: SellerSoldExtendedLifePurchaseOrderApiDto | null;
    purchaseOrder?: MyTraderaPurchaseOrderApiDto | null;
}

export interface SellerState {
    feedbackLeft: boolean;
    hidden: boolean;
    paid: boolean;
    shipped: boolean;
    shippingBooked: boolean;
    state: SellerStateEnum;
    upiSubmitted: boolean;
}

export interface SellerStateApiDto {
    feedbackLeft: boolean;
    isMcpSubmitted: boolean;
    isUpiSubmitted: boolean;
}

export enum SellerStateEnum {
    NotPaid = 'NotPaid',
    Paid = 'Paid',
    Shipped = 'Shipped',
    Done = 'Done',
}

export interface SellerTransactionData {
    disputeV2?: DisputeV2 | null;
    bookedShipment?: BookedShipment | null;
    buyer?: Member | null;
    discounts?: Discount[] | null;
    dispute?: Dispute | null;
    hasBuyerProtection: boolean;
    hasUnpaidShipping: boolean;
    isDiscountAfterPaymentSupported: boolean;
    isDiscountBeforePaymentSupported: boolean;
    isPaidWithIntegratedPaymentOption: boolean;
    isPaymentExpired: boolean;
    isPaynovaPayment: boolean;
    /** @format int32 */
    orderNumber?: number | null;
    /** @format uuid */
    paidShipmentCheckoutId?: string | null;
    paidStatus?: string | null;
    /** @format int32 */
    price: number;
    /** @format uuid */
    purchaseOrderId?: string | null;
    selectedShipping?: SelectedShipping | null;
    sellerState?: SellerState | null;
    /** @format uuid */
    shipmentId?: string | null;
    /** @deprecated */
    shippingDiscount?: ShippingDiscount | null;
    trackingLink?: string | null;
    transactionDate?: FormattedDate | null;
    /** @format int32 */
    transactionId: number;
    /** @format uuid */
    unpaidShippingId?: string | null;
    unpaidShippingUrl?: string | null;
}

export interface SellerTransactionForLeaveFeedbackDto {
    imageUrl?: string | null;
    itemUrl?: string | null;
    shortDescription?: string | null;
    /** @format date-time */
    transactionDate: string;
    /** @format int32 */
    transactionId: number;
    upiUrl?: string | null;
}

export interface ShipmentApiDto {
    hasProviderBookingFailed: boolean;
    hasShipmentLabel: boolean;
    hasShipmentReceipt: boolean;
    isAwaitingProviderBookingResponse: boolean;
    isBooked: boolean;
    isCancellable: boolean;
    isCancelled: boolean;
    isPaid: boolean;
    isSoldByTradera: boolean;
    labellessShippingCode?: string | null;
    packageRequirements?: CheckoutPackageRequirements | null;
    qrCodeImageStatus?: string | null;
    qrCodeImageUrl?: string | null;
    /** @format uuid */
    shipmentCheckoutId: string;
    /** @format uuid */
    shipmentId: string;
    shippingProvider?: string | null;
    trackingId?: string | null;
    /** @format int32 */
    transactionId: number;
    url?: string | null;
    /** @format double */
    weight: number;
}

export interface Address {
    city?: string | null;
    country?: string | null;
    countryCode?: string | null;
    email?: string | null;
    name?: string | null;
    phone?: string | null;
    street?: string | null;
    zipcode?: string | null;
}

export interface AgentDto {
    city?: string | null;
    countryCode?: string | null;
    id?: string | null;
    name?: string | null;
    serviceHours?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
}

export interface BookingInfo {
    digitalStampCode?: string | null;
    labellessShippingCode?: string | null;
    qrCodeImageStatus?: string | null;
    qrCodeImageUrl?: string | null;
    url?: string | null;
}

export interface ItemInfo {
    buyerMemberAlias?: string | null;
    /** @format int32 */
    buyerMemberId: number;
    /** @format int32 */
    itemId: number;
    itemImageUrlTemplate?: string | null;
    ownReferences?: string[] | null;
    shortDescription?: string | null;
}

export interface PackageRequirements {
    displaySize?: string | null;
    /** @format double */
    maxHeight?: number | null;
    /** @format double */
    maxLength?: number | null;
    /** @format double */
    maxLengthPlusCircumference?: number | null;
    /** @format double */
    maxSumOfAllSides?: number | null;
    /** @format double */
    maxSumOfLengthAndHeight?: number | null;
    /** @format double */
    maxVolume?: number | null;
    /** @format double */
    maxWeight?: number | null;
    /** @format double */
    maxWidth?: number | null;
    /** @format double */
    minHeight?: number | null;
    /** @format double */
    minLength?: number | null;
    /** @format double */
    minWeight?: number | null;
    /** @format double */
    minWidth?: number | null;
    restrictions?: string[] | null;
}

export interface Product {
    /** @format int32 */
    dimensionsExceededPenalty: number;
    displayPenaltyWarning: boolean;
    fromCountry?: string | null;
    hasFullyIntegratedShipmentBooking: boolean;
    hideOnSyi: boolean;
    /** @format int32 */
    id: number;
    /** @format double */
    lowestRelevantMaxWeight?: number | null;
    name?: string | null;
    officialName?: string | null;
    packageRequirements?: PackageRequirements | null;
    partnerProviderId?: string | null;
    /** @format int32 */
    price: number;
    providerId?: string | null;
    toCountry?: string | null;
    /** @format int32 */
    vatPercent?: number | null;
    /** @format double */
    weight: number;
    /** @format int32 */
    weightExceededPenalty: number;
}

export interface ShippingApiDto {
    priceRange?: ShippingPriceRangeApiDto | null;
    selectedShipping?: ShippingOptionApiDto | null;
    shipping?: ShipmentApiDto | null;
    /** @deprecated */
    shippingDiscount?: ShippingDiscountApiDto | null;
    shippingOptions?: ShippingOptionApiDto[] | null;
    unpaidShipping?: UnpaidShipmentApiDto | null;
}

export interface ShippingDiscountApiDto {
    toCountryCodeIso2?: string | null;
    /** @format date-time */
    created: string;
    partnerProvider?: string | null;
    shippingCost?: string | null;
    shippingType?: string | null;
    /** @format date-time */
    updated: string;
}

export interface ShippingFeeRuleApiDto {
    /** @format int32 */
    freeShippingCostLimit: number;
    useFreeShippingCostLimit: boolean;
}

export interface OutputShippingOption {
    partnerProvider?: string | null;
    /** @format double */
    shippingCost: number;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingType?: string | null;
    sizeCategory?: string | null;
}

export interface ShippingOptionApiDto {
    fromCountryCodeIso2?: string | null;
    toCountryCodeIso2?: string | null;
    partnerProvider?: string | null;
    shippingCost?: string | null;
    /** @format int32 */
    shippingProductId: number;
    shippingType?: string | null;
    sizeCategory?: string | null;
}

export interface ShippingPriceRangeApiDto {
    /** @format double */
    maxPrice: number;
    /** @format double */
    minPrice: number;
}

export interface Statistics {
    values?: StatisticsValue[] | null;
}

export interface StatisticsValue {
    key?: string | null;
    /** @deprecated */
    label?: string | null;
    value?: string | null;
}

export interface TimeLeft {
    critical: boolean;
    timeleft?: string | null;
}

export interface TransactionApiDto {
    disputeV2?: DisputeV2 | null;
    isStartDisputeV2OverDue: boolean;
    buyerState?: BuyerStateApiDto | null;
    discounts?: DiscountApiDto[] | null;
    dispute?: Dispute | null;
    /** @format double */
    price: number;
    sellerState?: SellerStateApiDto | null;
    /** @format date-time */
    transactionDate: string;
    /** @format int32 */
    transactionId: number;
}

export interface UnpaidShipmentApiDto {
    /** @format uuid */
    id: string;
    url?: string | null;
}

export interface CancelInvoicePaymentAttemptApiRequest {
    /** @format uuid */
    invoicePaymentAttemptId: string;
}

export interface CancelInvoicePaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface GetInvoiceBraintreeClientTokenApiResponse {
    clientToken?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetInvoiceCheckoutViewModelApiResponse {
    invoice?: InvoiceCheckoutInvoice | null;
    ongoingPaymentAttempt?: InvoiceCheckoutOngoingPaymentAttempt | null;
    responseStatus?: ResponseStatus | null;
    sellerPhone?: string | null;
}

export interface GetInvoicePaymentAttemptAuthenticationDataApiResponse {
    authenticationType?: string | null;
    responseStatus?: ResponseStatus | null;
    swishHandel?: SwishHandelInvoiceAuthenticationDataDto | null;
}

export interface GetInvoicePaymentAttemptStatusApiResponse {
    paymentMethodStatus?: string | null;
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface GetInvoicePaymentOptionsApiResponse {
    paymentOptions?: InvoicePaymentOptionApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface InitializeInvoicePaymentAttemptApiRequest {
    /** @format int64 */
    invoiceId: number;
    /** @format uuid */
    invoicePaymentAttemptId: string;
    paymentMethod?: string | null;
    paymentMethodData?: InvoiceCheckoutPaymentMethodDataDto | null;
}

export interface InitializeInvoicePaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface InvoiceCheckoutInvoice {
    /** @format double */
    amountIncludingVat: number;
    /** @format double */
    amountOwed?: number | null;
    /** @format date-time */
    dueDate: string;
    /** @format date-time */
    invoiceDate: string;
    /** @format int64 */
    invoiceId: number;
    /** @format int64 */
    ocr: number;
}

export interface InvoiceCheckoutPaymentMethodDataDto {
    clientToken?: string | null;
    deviceData?: string | null;
    nonce?: string | null;
    swishNumber?: string | null;
}

export interface InvoicePaymentOptionApiDto {
    paymentOption?: string | null;
    status?: string | null;
}

export interface InvoiceCheckoutOngoingPaymentAttempt {
    /** @format uuid */
    invoicePaymentAttemptId?: string | null;
    paymentMethod?: string | null;
}

export interface SwishHandelInvoiceAuthenticationDataDto {
    token?: string | null;
}

export interface CreateOrderInfoPdfApiRequest {
    /** @format uuid */
    purchaseOrderId: string;
}

export interface CreateOrderInfoPdfApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum FeedbackRatingDto {
    None = 'None',
    Negative = 'Negative',
    Positive = 'Positive',
}

export interface GetOrderInfoPdfApiResponse {
    document?: OrderInfoPdfApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface OrderInfoApiResponse {
    bookedShipping?: OrderInfoBookedShipping | null;
    buyerContactDetails?: ContactDetailsApiDto | null;
    feedback?: OrderInfoFeedback | null;
    orderData?: OrderInfoOrderData | null;
    responseStatus?: ResponseStatus | null;
    sellerContactDetails?: ContactDetailsApiDto | null;
}

export interface OrderInfoBookedShipping {
    /** @format uuid */
    shipmentId: string;
    shippingProvider?: string | null;
    trackingId?: string | null;
    trackingLink?: string | null;
    trackingLinkLabel?: string | null;
}

export interface OrderInfoFeedback {
    comment?: string | null;
    rating: FeedbackRatingDto;
}

export interface OrderInfoOrderData {
    isGiftCardOrder: boolean;
    isPaid: boolean;
    /** @format int32 */
    itemId: number;
    memberIsBuyer: boolean;
    /** @format int32 */
    orderNumber: number;
    selectedShipping?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface OrderInfoPdfApiDto {
    contentType?: string | null;
    /** @format byte */
    fileContents?: string | null;
}

export type OutstandingBuyerActionsApiRequest = object;

export interface OutstandingBuyerActionsApiResponse {
    /** @format int64 */
    notLeftFeedbackCount: number;
    /** @format int64 */
    notPaidCount: number;
    /** @format int64 */
    outbiddedCount: number;
    responseStatus?: ResponseStatus | null;
}

export type OutstandingSellerActionsApiRequest = object;

export interface OutstandingSellerActionsApiResponse {
    /** @format int64 */
    enterCombinedShippingCount: number;
    /** @format int64 */
    notLeftFeedbackCount: number;
    /** @format int64 */
    notPaidCount: number;
    /** @format int64 */
    notShippedCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface OverviewApiResponse {
    buyerActions?: OutstandingBuyerActions | null;
    buyerOngoing?: PreviewListBuyerItem | null;
    buyerPurchases?: PreviewListBuyerItem | null;
    responseStatus?: ResponseStatus | null;
    sellerActions?: OutstandingSellerActions | null;
    sellerActive?: PreviewListSellerItem | null;
    sellerSold?: PreviewListSellerItem | null;
    stats?: OverviewStats | null;
}

export interface AddressApiDto {
    countryCodeIso2?: string | null;
    city?: string | null;
    country?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
}

export interface BuyerMemberApiDto {
    /** @format int32 */
    memberId: number;
}

export interface CancelDiscountApiRequest {
    /** @format int32 */
    discountId: number;
}

export interface CancelDiscountApiResponse {
    error?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CancelDiscountPaymentAttemptApiRequest {
    /** @format uuid */
    discountPaymentAttemptId: string;
}

export interface CancelDiscountPaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ExistingDiscountApiDto {
    /** @format double */
    amount: number;
    /** @format date-time */
    createdDate: string;
    discountedPart?: string | null;
    /** @format int32 */
    id: number;
    /** @format int32 */
    transactionId?: number | null;
}

export interface DiscountCheckoutPaymentMethodDataDto {
    clientToken?: string | null;
    deviceData?: string | null;
    nonce?: string | null;
    swishNumber?: string | null;
}

export interface DiscountPaymentAttemptApiDto {
    /** @format int32 */
    discountId: number;
    /** @format uuid */
    discountPaymentAttemptId: string;
    /** @format int32 */
    payerMemberId: number;
    /** @format double */
    paymentAmount: number;
    paymentMethod?: string | null;
    paymentMethodStatus?: string | null;
    status?: string | null;
}

export interface DiscountPaymentOptionApiDto {
    extras?: DiscountPaymentOptionExtrasApiDto | null;
    isPrioritized: boolean;
    paymentOption?: string | null;
    status?: string | null;
}

export interface DiscountPaymentOptionExtrasApiDto {
    /** @format double */
    availableBalance?: number | null;
    isPayoutOngoing?: boolean | null;
}

export interface GetDiscountAttemptApiResponse {
    /** @format int32 */
    discountId: number;
    error?: string | null;
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface GetDiscountBraintreeClientTokenApiResponse {
    clientToken?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDiscountCheckoutViewModelApiResponse {
    ongoingPaymentAttempt?: DiscountPaymentAttemptApiDto | null;
    purchaseOrder?: GetDiscountPurchaseOrderApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDiscountItemApiDto {
    discounts?: DiscountTransactionDiscountDto[] | null;
    images?: DiscountImagesApiDto | null;
    /** @format int32 */
    itemId: number;
    /** @format double */
    itemPriceAfterDiscount: number;
    itemUrl?: string | null;
    /** @format double */
    price: number;
    shortDescription?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface GetDiscountPaymentAttemptAuthenticationDataApiResponse {
    authenticationType?: string | null;
    responseStatus?: ResponseStatus | null;
    swishHandel?: SwishHandelDiscountAuthenticationDataDto | null;
}

export interface GetDiscountPaymentAttemptStatusApiResponse {
    paymentMethodStatus?: string | null;
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export type GetDiscountPaymentOptionsApiRequest = object;

export interface GetDiscountPaymentOptionsApiResponse {
    paymentOptions?: DiscountPaymentOptionApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDiscountPurchaseOrderApiDto {
    buyerMember?: BuyerMemberApiDto | null;
    discounts?: ExistingDiscountApiDto[] | null;
    items?: GetDiscountItemApiDto[] | null;
    ongoingDiscount?: ExistingDiscountApiDto | null;
    /** @format int32 */
    orderNumber: number;
    sellerMember?: SellerMemberApiDto | null;
    /** @format double */
    shippingAmount?: number | null;
    state?: DiscountPurchaseOrderStateApiDto | null;
    /** @format double */
    totalAmount?: number | null;
    /** @format double */
    totalDiscountItemAmount: number;
    /** @format double */
    totalDiscountShippingAmount: number;
    /** @format double */
    totalDiscountableAmount: number;
    /** @format double */
    totalItemAmount: number;
}

export interface DiscountImageApiDto {
    full?: string | null;
    medium?: string | null;
    multiThumbnail?: string | null;
    smallFit?: string | null;
}

export interface DiscountImagesApiDto {
    main?: DiscountImageApiDto | null;
}

export interface InitializeDiscountAttemptApiRequest {
    /** @format double */
    amount: number;
    /** @format uuid */
    discountAttemptId: string;
    discountedPart?: string | null;
    /** @format int32 */
    discountedTransactionId?: number | null;
    /** @format uuid */
    purchaseOrderId: string;
}

export interface InitializeDiscountAttemptApiResponse {
    error?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface InitializeDiscountPaymentAttemptApiRequest {
    /** @format int32 */
    discountId: number;
    /** @format uuid */
    discountPaymentAttemptId: string;
    paymentMethod?: string | null;
    paymentMethodData?: DiscountCheckoutPaymentMethodDataDto | null;
}

export interface InitializeDiscountPaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface DiscountPurchaseOrderStateApiDto {
    isDiscountAllowed: boolean;
    isRefundAllowed: boolean;
}

export interface SellerMemberApiDto {
    address?: AddressApiDto | null;
    alias?: string | null;
    emailAddress?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    /** @format int32 */
    memberId: number;
    personalNumber?: string | null;
    phoneNumber?: string | null;
}

export interface SwishHandelDiscountAuthenticationDataDto {
    token?: string | null;
}

export interface DiscountTransactionDiscountDto {
    /** @format double */
    amount: number;
    /** @format int32 */
    id: number;
}

export interface ResellSuggestionsApiResponse {
    items?: ItemCardViewModel[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface SellerActiveApiRequest {
    parameters?: SearchParameters | null;
}

export interface SellerActiveApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: SellerNonTransactionalItemResult | null;
}

export interface SellerListingStats {
    /** @format int32 */
    freeListingsCount: number;
    /** @format int32 */
    listedThisMonthCount: number;
    /** @format int32 */
    maxFreeListingsPerMonth: number;
    responseStatus?: ResponseStatus | null;
}

export interface SellerListingsApiRequest {
    parameters?: SearchParameters | null;
}

export interface SellerListingsApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: SellerNonTransactionalItemResult | null;
}

export interface OverviewSellerStatsActiveModel_Apps {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
}

export interface OverviewSellerStatsModel_Apps {
    active?: OverviewSellerStatsActiveModel_Apps | null;
    sold?: OverviewSellerStatsSoldModel_Apps | null;
    unsold?: OverviewSellerStatsUnsoldModel_Apps | null;
}

export interface OverviewSellerStatsSoldModel_Apps {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
}

export interface OverviewSellerStatsUnsoldModel_Apps {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
}

export interface SellerOverviewStatsApiResponse {
    /** @format int32 */
    listedThisMonthCount: number;
    /** @format int32 */
    maxFreeListingsPerMonth: number;
    responseStatus?: ResponseStatus | null;
    sellerStats?: OverviewSellerStatsModel_Apps | null;
}

export interface SellerSoldApiRequest {
    parameters?: SearchParameters | null;
}

export interface SellerSoldApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: SellerSoldItemResult | null;
}

export interface SellerSoldPurchaseOrderApiResponse {
    purchaseOrder?: MyTraderaPurchaseOrderApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface SellerSoldPurchaseOrdersApiRequest {
    dateFrom?: string | null;
    dateTo?: string | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
    sellerFilters?: PurchaseOrderSellerStateFilters | null;
}

export interface SellerSoldPurchaseOrdersApiResponse {
    purchaseOrders?: MyTraderaPurchaseOrderApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    statistics?: Statistics | null;
    /** @format int32 */
    totalNumberOfPages: number;
    /** @format int32 */
    totalNumberOfPurchaseOrders: number;
    /** @format int32 */
    trackedHistoryLengthInMonths?: number | null;
}

export interface SellerSoldPurchaseOrdersIncludingExtendedLifeApiRequest {
    dateFrom?: string | null;
    dateTo?: string | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
    sellerFilters?: PurchaseOrderSellerStateFilters | null;
}

export interface SellerSoldPurchaseOrdersIncludingExtendedLifeApiResponse {
    purchaseOrdersOneOf?: SellerSoldPurchaseOrderOneOfApiDto[] | null;
    responseStatus?: ResponseStatus | null;
    statistics?: Statistics | null;
    /** @format int32 */
    totalNumberOfPages: number;
    /** @format int32 */
    totalNumberOfPurchaseOrders: number;
    /** @format int32 */
    trackedHistoryLengthInMonths?: number | null;
}

export interface SellerStatsActiveApiDto {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
}

export interface SellerStatsApiResponse {
    active?: SellerStatsActiveApiDto | null;
    responseStatus?: ResponseStatus | null;
    sold?: SellerStatsSoldApiDto | null;
    stats?: SellerListingStats | null;
    unsold?: SellerStatsUnsoldApiDto | null;
}

export interface SellerStatsSoldApiDto {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
    /** @format int32 */
    totalPrice: number;
}

export interface SellerStatsUnsoldApiDto {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
}

export interface SellerUnsoldApiRequest {
    parameters?: SearchParameters | null;
}

export interface SellerUnsoldApiResponse {
    responseStatus?: ResponseStatus | null;
    result?: SellerNonTransactionalItemResult | null;
}

export interface ShipmentCheckoutAddress {
    countryCodeIso2?: string | null;
    alias?: string | null;
    city?: string | null;
    country?: string | null;
    email?: string | null;
    name?: string | null;
    phoneNumber?: string | null;
    street?: string | null;
    zipCode?: string | null;
}

export interface BuyerAddress {
    city?: string | null;
    name?: string | null;
    phoneNumber?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
}

export interface CancelShipmentPaymentAttemptApiRequest {
    /** @format uuid */
    shipmentPaymentAttemptId: string;
}

export interface CancelShipmentPaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export type CreateShipmentCheckoutV2ApiRequest = object;

export interface CreateShipmentCheckoutV2ApiResponse {
    ongoingPaymentAttempt?: ShipmentCheckoutOngoingPaymentAttempt | null;
    responseStatus?: ResponseStatus | null;
    sellerPhone?: string | null;
    /** @format uuid */
    shipmentCheckoutId: string;
    shipments?: ShipmentCheckoutShipmentDto[] | null;
}

export interface DeliveryInformation {
    estimatedDeliveryTime?: EstimatedDeliveryTime | null;
    insurance?: Insurance | null;
    isServicePoint: boolean;
}

export interface EstimatedDeliveryTime {
    /** @format int32 */
    maxWeekdays?: number | null;
    /** @format int32 */
    minWeekdays: number;
}

export interface GetIsBookingCompleteByShippingCheckoutIdApiResponse {
    isBookingComplete: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentBraintreeClientTokenApiResponse {
    clientToken?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentPaymentAttemptAuthenticationDataApiResponse {
    authenticationType?: string | null;
    responseStatus?: ResponseStatus | null;
    swishHandel?: SwishHandelShipmentAuthenticationDataDto | null;
}

export interface GetShipmentPaymentAttemptStatusApiResponse {
    paymentMethodStatus?: string | null;
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface GetShipmentPaymentOptionsApiResponse {
    paymentOptions?: ShipmentPaymentOptionApiDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface InitializeShipmentPaymentAttemptApiRequest {
    paymentMethod?: string | null;
    paymentMethodData?: ShipmentCheckoutPaymentMethodDataDto | null;
    /** @format uuid */
    shipmentCheckoutId: string;
    /** @format uuid */
    shipmentPaymentAttemptId: string;
}

export interface InitializeShipmentPaymentAttemptApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface Insurance {
    /** @format double */
    amountPerKilogram?: number | null;
    hasReimbursementUpToPackageCost: boolean;
    /** @format double */
    totalAmount?: number | null;
    /** @format double */
    totalAmountUpToItemValue?: number | null;
}

export interface ShipmentCheckoutOngoingPaymentAttempt {
    paymentMethod?: string | null;
    /** @format uuid */
    shipmentPaymentAttemptId?: string | null;
}

export interface CheckoutPackageRequirements {
    /** @format double */
    maxHeight?: number | null;
    /** @format double */
    maxLength?: number | null;
    /** @format double */
    maxLengthPlusCircumference?: number | null;
    /** @format double */
    maxSumOfAllSides?: number | null;
    /** @format double */
    maxSumOfLengthAndHeight?: number | null;
    /** @format double */
    maxVolume?: number | null;
    /** @format double */
    maxWeight?: number | null;
    /** @format double */
    maxWidth?: number | null;
    /** @format double */
    minHeight?: number | null;
    /** @format double */
    minLength?: number | null;
    /** @format double */
    minWidth?: number | null;
    restrictions?: string[] | null;
}

export interface CheckoutProduct {
    deliveryInformation?: DeliveryInformation | null;
    /** @format int32 */
    id: number;
    packageRequirements?: CheckoutPackageRequirements | null;
}

export interface SaveShippingDetailsV2ApiRequest {
    shippingDetails?: ShipmentCheckoutShippingDetails | null;
}

export interface SaveShippingDetailsV2ApiResponse {
    isShippingFreeBasedOnCharity: boolean;
    responseStatus?: ResponseStatus | null;
    shipmentCheckoutId?: string | null;
    shipmentId?: string | null;
}

export interface ShipmentCheckoutPaymentMethodDataDto {
    clientToken?: string | null;
    deviceData?: string | null;
    nonce?: string | null;
    swishNumber?: string | null;
}

export interface ShipmentCheckoutShipmentDto {
    /** @format date-time */
    activeAt: string;
    /** @format int32 */
    allowedBuyerRegion: number;
    buyerAlias?: string | null;
    buyerFirstName?: string | null;
    buyerLastName?: string | null;
    dropOffPoint?: string | null;
    hasShipmentNote: boolean;
    isSoldByTradera: boolean;
    /**
     * @deprecated
     * @format int32
     */
    itemCost: number;
    /** @deprecated */
    itemDescription?: string | null;
    /**
     * @deprecated
     * @format int32
     */
    itemId: number;
    /** @deprecated */
    itemImageUrl?: string | null;
    /** @deprecated */
    itemImageUrlTemplate?: string | null;
    items?: ShipmentItem[] | null;
    officialName?: string | null;
    /** @format int32 */
    orderNumber: number;
    /** @format double */
    packageWeight: number;
    parcelIds?: string[] | null;
    product?: CheckoutProduct | null;
    /** @format uuid */
    purchaseOrderId: string;
    receiver?: ShipmentCheckoutAddress | null;
    shipmentId?: string | null;
    shipmentNumber?: string | null;
    shippingInfo?: string | null;
    /** @format double */
    shippingPrice: number;
    shippingProvider?: string | null;
    showShipmentNumberToMember: boolean;
    termsAndConditions?: TermsAndConditions | null;
}

export interface ShipmentItem {
    /** @format double */
    cost: number;
    description?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    itemId: number;
}

export interface ShipmentPaymentOptionApiDto {
    paymentOption?: string | null;
    status?: string | null;
}

export interface ShipmentCheckoutShippingDetails {
    buyerAddress?: BuyerAddress | null;
    /** @format uuid */
    purchaseOrderId: string;
    shipmentId?: string | null;
    /** @format int32 */
    shippingProductId: number;
    shippingProvider?: string | null;
}

export interface SwishHandelShipmentAuthenticationDataDto {
    token?: string | null;
}

export interface ShippingAddress {
    countryCodeIso2?: string | null;
    city?: string | null;
    name?: string | null;
    street?: string | null;
    zipCode?: string | null;
}

export interface BookedShipmentDto {
    agent?: AgentDto | null;
    bookingInfo?: BookingInfo | null;
    itemInfos?: ItemInfo[] | null;
    /** @format int32 */
    memberId: number;
    product?: Product | null;
    /** @format uuid */
    purchaseOrderId: string;
    receiver?: Address | null;
    sellerClosestAgent?: AgentDto | null;
    /** @format uuid */
    shipmentId: string;
}

export interface BuyerDetailsDto {
    city?: string | null;
    name?: string | null;
    phoneNumber?: string | null;
    streetName?: string | null;
    zipCode?: string | null;
}

export interface CancelShipmentApiRequest {
    /** @format uuid */
    shipmentId: string;
}

export interface CancelShipmentApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface CreateShippingComplaintImageUploadUrlApiRequest {
    contentType?: string | null;
}

export interface CreateShippingComplaintImageUploadUrlApiResponse {
    objectName?: string | null;
    responseStatus?: ResponseStatus | null;
    uploadUrl?: string | null;
}

export interface DeleteShipmentApiRequest {
    /** @format uuid */
    shipmentId: string;
}

export interface DeleteShipmentApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface GetBookedShipmentByPurchaseOrderIdApiResponse {
    bookedShipment?: BookedShipmentDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetBookedShipmentByShipmentCheckoutIdApiResponse {
    /** @deprecated */
    bookedShipment?: BookedShipmentDto | null;
    bookedShipments?: BookedShipmentDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetChangeCombinedShippingViewModelApiRequest = object;

export interface GetChangeCombinedShippingViewModelApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentAgentsForAddressApiResponse {
    agents?: string[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentProductForShipmentApiResponse {
    product?: CheckoutProduct | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentReceiptApiResponse {
    /** @format byte */
    content?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShipmentsByCheckoutIdApiResponse {
    hasCombinedFreightLabel: boolean;
    isBookingComplete: boolean;
    responseStatus?: ResponseStatus | null;
    shipments?: ShippingShipmentDto[] | null;
}

export interface GetShipmentsWithQrCodesThatAreReadyToBeShippedApiResponse {
    bookedShipments?: BookedShipmentDto[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalBookedShipments: number;
}

export interface GetShippingComplaintDataApiResponse {
    formData?: ShippingComplaintFormData | null;
    items?: ShippingComplaintItemDetails[] | null;
    receiver?: ShippingComplaintContactInformation | null;
    reportDamagedGoodsUrl?: string | null;
    responseStatus?: ResponseStatus | null;
    sender?: ShippingComplaintContactInformation | null;
    shippingProvider?: string | null;
    /** @format date-time */
    submittedDate?: string | null;
}

export type GetUnbookedShipmentsApiRequest = object;

export interface GetUnbookedShipmentsApiResponse {
    responseStatus?: ResponseStatus | null;
    unbookedShipments?: UnbookedShipmentDto[] | null;
}

export interface ItemDto {
    /** @format double */
    cost: number;
    description?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    itemId: number;
}

export interface SaveShippingComplaintDataApiRequest {
    formData?: ShippingComplaintFormData | null;
    /** @format uuid */
    shipmentId: string;
}

export interface SaveShippingComplaintDataApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format date-time */
    submittedDate: string;
}

export interface ShippingShipmentDto {
    bookingInfo?: BookingInfo | null;
    buyerAlias?: string | null;
    digitalStampCode?: string | null;
    dropOffPoint?: string | null;
    hasShipmentNote: boolean;
    isSoldByTradera: boolean;
    itemDescription?: string | null;
    /** @format int32 */
    itemId: number;
    itemImageUrl?: string | null;
    itemImageUrlTemplate?: string | null;
    labellessShippingCode?: string | null;
    officialName?: string | null;
    parcelIds?: string[] | null;
    qrCodeImageStatus?: string | null;
    qrCodeImageUrl?: string | null;
    receiver?: ShippingAddress | null;
    shipmentId?: string | null;
    shipmentNumber?: string | null;
    shippingInfo?: string | null;
    /** @format double */
    shippingPrice: number;
    shippingProvider?: string | null;
    shippingProviderImageUrl?: string | null;
    showShipmentNumberToMember: boolean;
    smallItemImageUrl?: string | null;
    termsAndConditions?: TermsAndConditions | null;
    /** @format double */
    weight: number;
}

export interface ShippingComplaintContactInformation {
    email?: string | null;
    /** @format int32 */
    memberId: number;
    name?: string | null;
    phone?: string | null;
}

export interface ShippingComplaintFormData {
    additionalComments?: string | null;
    complaintDescription?: string | null;
    complaintImages?: ShippingComplaintImage[] | null;
    complaintReason?: string | null;
    packingDescription?: string | null;
}

export interface ShippingComplaintImage {
    filename?: string | null;
    objectName?: string | null;
}

export interface ShippingComplaintItemDetails {
    /** @format int32 */
    itemId: number;
    /** @format double */
    price: number;
    shortDescription?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface ShippingProductDto {
    /** @format double */
    shippingPrice: number;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingProvider?: string | null;
}

export interface TermsAndConditions {
    general?: string | null;
    termsAndConditionUrl?: string | null;
    termsOfPurchase?: string | null;
    termsOfService?: string | null;
}

export interface UnbookedShipmentDto {
    buyerDetails?: BuyerDetailsDto | null;
    items?: ItemDto[] | null;
    /** @format int32 */
    orderNumber: number;
    /** @format uuid */
    purchaseOrderId: string;
    quickFlowPossible: boolean;
    selectedShipping?: ShippingProductDto | null;
}

export interface SystemBadge {
    /** @format int32 */
    count: number;
    type: SystemBadgeType;
    value?: string | null;
}

export enum SystemBadgeType {
    PayoutsActivity = 'PayoutsActivity',
    SellerNotPaid = 'SellerNotPaid',
    SellerNotShipped = 'SellerNotShipped',
    SellerNotLeftFeedback = 'SellerNotLeftFeedback',
    BuyerOutbid = 'BuyerOutbid',
    BuyerNotPaid = 'BuyerNotPaid',
    BuyerNotLeftFeedback = 'BuyerNotLeftFeedback',
    WalletBalance = 'WalletBalance',
    CombinedShippingPriceRequested = 'CombinedShippingPriceRequested',
}

export type SystemBadgesApiRequest = object;

export interface SystemBadgesApiResponse {
    badges?: SystemBadge[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface AccountingEntry {
    /** @format double */
    amount: number;
    /** @format date-time */
    createdDate: string;
    entryType?: string | null;
    hasSpecification: boolean;
    /** @format int32 */
    sequenceNumber: number;
}

export interface CreditMemoReturn {
    /** @format int64 */
    creditMemoId: number;
}

export interface EntryRow {
    /** @format double */
    amount: number;
    /** @format double */
    balance: number;
    buyerAlias?: string | null;
    /** @format date-time */
    createdDate?: string | null;
    entryType?: string | null;
    /** @format double */
    itemAmount?: number | null;
    itemIds?: number[] | null;
    orderNumber?: string | null;
    paymentType?: string | null;
    /** @format int32 */
    sequenceNumber: number;
    /** @format double */
    shippingAmount?: number | null;
    shortDescription?: string | null;
}

export interface Fee {
    feeDescription?: string | null;
    /** @format int32 */
    feeGroup: number;
    /** @format int32 */
    feeType: number;
}

export interface WalletInvoice {
    hasSpecification: boolean;
    /** @format int64 */
    invoiceId: number;
    invoiceNumber?: string | null;
    /** @format int32 */
    month: number;
}

export interface ManualPayoutStatusApiResponse {
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface WalletOrder {
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    itemId: number;
    orderNumber?: string | null;
    shortDescription?: string | null;
}

export interface Payment {
    paymentType?: string | null;
}

export interface Payout {
    payoutReference?: string | null;
}

export interface PayoutCreditMemoReturn {
    /** @format int64 */
    creditMemoId: number;
}

export interface PayoutFee {
    feeDescription?: string | null;
    item?: string | null;
}

export interface PayoutPayment {
    paymentType?: string | null;
}

export type PayoutStatusApiRequest = object;

export interface PayoutStatusApiResponse {
    account?: string | null;
    accountStatus?: string | null;
    accountType?: string | null;
    /** @format double */
    amount: number;
    /** @format int32 */
    highlightFrom: number;
    isNextPayoutAttemptFirstManualAttempt: boolean;
    isPayoutInProgress: boolean;
    kycProblems?: string[] | null;
    /** @format int32 */
    lastSequenceNumber?: number | null;
    /** @format date-time */
    nextPayoutAttempt?: string | null;
    payoutFrequencyOption?: string | null;
    payoutOptionStatus?: string | null;
    problems?: string[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface PayoutsEntry {
    /** @format double */
    amount: number;
    /** @format double */
    balance: number;
    buyer?: PayoutsEntryBuyer | null;
    /** @format date-time */
    createdDate?: string | null;
    creditMemoReturn?: CreditMemoReturn | null;
    entryType?: string | null;
    fee?: Fee | null;
    invoice?: WalletInvoice | null;
    order?: WalletOrder | null;
    payment?: Payment | null;
    payout?: Payout | null;
    /** @format uuid */
    purchaseOrderId?: string | null;
    /** @format int32 */
    sequenceNumber: number;
}

export interface PayoutsEntryBuyer {
    alias?: string | null;
    cleanedAlias?: string | null;
    /** @format int32 */
    memberId: number;
}

export interface PayoutsViewStatusApiRequest {
    /** @format int32 */
    lastSequenceNumberSeen: number;
}

export interface PayoutsViewStatusApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface PendingEntry {
    /** @format double */
    amount: number;
    buyer?: PendingEntryBuyer | null;
    /** @format date-time */
    createdDate: string;
    entryType?: string | null;
    item?: string | null;
    order?: PendingEntryOrder | null;
    orderNumber?: string | null;
    /** @format uuid */
    purchaseOrderId: string;
}

export interface PendingEntryBuyer {
    alias?: string | null;
    cleanedAlias?: string | null;
    /** @format int32 */
    memberId: number;
}

export interface PendingEntryOrder {
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    itemId: number;
    orderNumber?: string | null;
    shortDescription?: string | null;
}

export interface PerformManualPayoutApiRequest {
    /** @format double */
    amount: number;
    /** @format int32 */
    sequenceNumber: number;
}

export interface PerformManualPayoutApiResponse {
    errorMessage?: string | null;
    isSuccessful: boolean;
    /** @format uuid */
    payoutAttemptId: string;
    responseStatus?: ResponseStatus | null;
}

export interface WalletAccountingEntriesApiResponse {
    entries?: AccountingEntry[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface WalletCsvApiResponse {
    responseStatus?: ResponseStatus | null;
    rows?: EntryRow[] | null;
}

export interface WalletEntriesApiResponse {
    entries?: PayoutsEntry[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface WalletEntryDetailsApiResponse {
    responseStatus?: ResponseStatus | null;
    rows?: WalletEntryDetailsRow[] | null;
}

export interface WalletEntryDetailsRow {
    /** @format double */
    amount?: number | null;
    forCharity: boolean;
    /** @format int32 */
    itemId?: number | null;
    orderNumber?: string | null;
    /** @format uuid */
    purchaseOrderId: string;
    text?: string | null;
    type?: string | null;
}

export interface WalletPayoutDetails {
    accountNumber?: string | null;
    /** @format double */
    adjustment: number;
    creditMemoReturns?: WalletPayoutDetailsSection | null;
    /** @format date-time */
    endDate: string;
    entryType?: string | null;
    fees?: WalletPayoutDetailsSection | null;
    /** @format double */
    invoiceAmountLeft?: number | null;
    /** @format int64 */
    invoiceId?: number | null;
    /** @format double */
    invoiced: number;
    /** @format date-time */
    paidOutDate: string;
    payoutReference?: string | null;
    /** @format double */
    payoutRefunds: number;
    purchases?: WalletPayoutDetailsSection | null;
    revenue?: WalletPayoutDetailsSection | null;
    /** @format int32 */
    sequenceNumber: number;
    shipping?: WalletPayoutDetailsSection | null;
    /** @format date-time */
    startDate: string;
    /** @format double */
    totalPaid: number;
}

export interface WalletPayoutDetailsApiResponse {
    details?: WalletPayoutDetails[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface WalletPayoutDetailsRow {
    /** @format double */
    amount: number;
    creditMemoReturn?: PayoutCreditMemoReturn | null;
    entryType?: string | null;
    fee?: PayoutFee | null;
    item?: string | null;
    /** @format int32 */
    itemId?: number | null;
    /** @format int32 */
    orderNumber?: number | null;
    payment?: PayoutPayment | null;
    rowType?: string | null;
    /** @format double */
    vat?: number | null;
    /** @format int32 */
    vatPercentage?: number | null;
}

export interface WalletPayoutDetailsSection {
    entries?: WalletPayoutDetailsRow[] | null;
    /** @format double */
    totalAmount: number;
    /** @format double */
    totalVat: number;
}

export type WalletPendingApiRequest = object;

export interface WalletPendingApiResponse {
    pending?: PendingEntry[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface BoughtPageApiRequest {
    buyerFilters?: PurchaseOrderBuyerStateFilters | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
    query?: string | null;
    queryProperties?: string | null;
}

export interface BuyerGroupedLeaveFeedback {
    label?: string | null;
    purchaseOrders?: BuyerPurchaseOrderForLeaveFeedbackDto[] | null;
}

export interface GetBuyerPurchaseOrderForLeaveFeedbackApiResponse {
    purchaseOrder?: BuyerPurchaseOrderForLeaveFeedbackDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetBuyerPurchaseOrdersForLeaveFeedbackApiResponse {
    groups?: BuyerGroupedLeaveFeedback[] | null;
    /** @format int32 */
    remainingPurchaseOrdersCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetSellerPurchaseOrderForLeaveFeedbackApiResponse {
    purchaseOrder?: SellerPurchaseOrderForLeaveFeedbackDto | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetSellerPurchaseOrdersForLeaveFeedbackApiResponse {
    groups?: SellerGroupedLeaveFeedback[] | null;
    /** @format int32 */
    remainingPurchaseOrdersCount: number;
    responseStatus?: ResponseStatus | null;
}

export interface ItemCardAttributeViewModel {
    name?: string | null;
    values?: string[] | null;
}

export enum ItemCardSearchResultOrigin {
    Keyword = 'Keyword',
    Vector = 'Vector',
    KeywordAndVector = 'KeywordAndVector',
}

export interface ItemCardShippingOptionViewModel {
    /** @format int32 */
    cost: number;
    type?: string | null;
}

export interface ItemCardViewModel {
    attributes?: ItemCardAttributeViewModel[] | null;
    /** @format int32 */
    buyNowPrice: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    discountRate: number;
    displayHighlighted: boolean;
    /** @format date-time */
    endDate: string;
    hasFreeShipping: boolean;
    /** @format int32 */
    imageHeight?: number | null;
    imageSecondaryUrlTemplate?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    imageWidth?: number | null;
    inWishList?: boolean | null;
    isActive: boolean;
    isAuthenticated: boolean;
    isAvailableForOffers?: boolean | null;
    /** @format int32 */
    itemId: number;
    itemType?: string | null;
    itemUrl?: string | null;
    onDisplay: boolean;
    /** @format int32 */
    price: number;
    /** @format int32 */
    priceBeforeDiscount: number;
    reservedPriceReached: boolean;
    searchResultOrigin?: ItemCardSearchResultOrigin | null;
    sellerAlias?: string | null;
    /** @format double */
    sellerDsrAverage?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    shippingOptions?: ItemCardShippingOptionViewModel[] | null;
    shortDescription?: string | null;
    /** @format date-time */
    startDate: string;
    /** @format int32 */
    totalBids: number;
}

export interface OverviewItemCardModel {
    attributes?: ItemCardDtoItemCardAttribute[] | null;
    /** @format int32 */
    buyNowPrice: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    discountRate: number;
    displayHighlighted: boolean;
    /** @format date-time */
    endDate: string;
    hasFreeShipping: boolean;
    /** @format int32 */
    imageHeight?: number | null;
    imageSecondaryUrl?: string | null;
    imageSecondaryUrlTemplate?: string | null;
    imageUrl?: string | null;
    imageUrlTemplate?: string | null;
    /** @format int32 */
    imageWidth?: number | null;
    inWishList: boolean;
    isActive: boolean;
    isAuthenticated: boolean;
    isRestarted: boolean;
    /** @format int32 */
    itemId: number;
    itemState: OverviewItemState;
    itemType?: string | null;
    itemUrl?: string | null;
    onDisplay: boolean;
    /** @format int32 */
    price: number;
    /** @format int32 */
    priceBeforeDiscount: number;
    /** @format uuid */
    purchaseOrderId: string;
    reservedPriceReached: boolean;
    sellerAlias?: string | null;
    /** @format double */
    sellerDsrAverage?: number | null;
    /** @format int32 */
    sellerMemberId: number;
    shippingOptions?: ItemCardDtoShippingOption[] | null;
    shortDescription?: string | null;
    /** @format date-time */
    startDate: string;
    /** @format int32 */
    totalBids: number;
}

export enum OverviewItemState {
    Unknown = 'Unknown',
    SellerSoldDone = 'SellerSoldDone',
    SellerSoldShipped = 'SellerSoldShipped',
    SellerSoldPaid = 'SellerSoldPaid',
    SellerSoldNotPaid = 'SellerSoldNotPaid',
    SellerUnsoldClosed = 'SellerUnsoldClosed',
    SellerUnsoldNotSold = 'SellerUnsoldNotSold',
    SellerUnsoldRestarted = 'SellerUnsoldRestarted',
    SellerActiveBid = 'SellerActiveBid',
    SellerActiveActive = 'SellerActiveActive',
    BuyerPurchasesDone = 'BuyerPurchasesDone',
    BuyerPurchasesShipped = 'BuyerPurchasesShipped',
    BuyerPurchasesPaid = 'BuyerPurchasesPaid',
    BuyerPurchasesNotPaid = 'BuyerPurchasesNotPaid',
    BuyerOngoingLeadingBid = 'BuyerOngoingLeadingBid',
    BuyerOngoingOverBid = 'BuyerOngoingOverBid',
}

export interface OverviewListingCountModel {
    /** @format int32 */
    freeListingsCount: number;
    /** @format int32 */
    listedThisMonthCount: number;
    /** @format int32 */
    maxFreeListingsPerMonth: number;
}

export interface OverviewSellerStatsActiveModel {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
}

export interface OverviewSellerStatsModel {
    active?: OverviewSellerStatsActiveModel | null;
    sold?: OverviewSellerStatsSoldModel | null;
    unsold?: OverviewSellerStatsUnsoldModel | null;
}

export interface OverviewSellerStatsSoldModel {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
    /** @format int32 */
    totalPrice: number;
}

export interface OverviewSellerStatsUnsoldModel {
    /** @format int32 */
    auctionCount: number;
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    bidSum: number;
    /** @format int32 */
    buyItNowCount: number;
    /** @format int32 */
    fixedPriceCount: number;
    /** @format int32 */
    itemCount: number;
    /** @format int32 */
    shopItemCount: number;
    /** @format int32 */
    sumOpeningBids: number;
}

export interface SellerGroupedLeaveFeedback {
    isPaid: boolean;
    label?: string | null;
    purchaseOrders?: SellerPurchaseOrderForLeaveFeedbackDto[] | null;
}

export interface SoldPageApiRequest {
    dateFrom?: string | null;
    dateTo?: string | null;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
    query?: string | null;
    queryProperties?: string | null;
    sellerFilters?: PurchaseOrderSellerStateFilters | null;
}

export interface WebOverviewApiResponse {
    buyerActions?: OutstandingBuyerActions | null;
    buyerOngoing?: PreviewList | null;
    buyerPurchases?: PreviewList | null;
    listingCount?: OverviewListingCountModel | null;
    responseStatus?: ResponseStatus | null;
    sellerActions?: OutstandingSellerActions | null;
    sellerActive?: PreviewList | null;
    sellerSold?: PreviewList | null;
    sellerStats?: OverviewSellerStatsModel | null;
    sellerUnsold?: PreviewList | null;
}

export interface ShippingDiscount {
    partnerProvider?: string | null;
    /** @format int32 */
    price: number;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingProvider?: string | null;
}

export interface ShippingDtoAddress {
    countryCodeIso2?: string | null;
    country?: string | null;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
}

export interface Agent {
    city?: string | null;
    id?: string | null;
    name?: string | null;
    serviceHours?: string | null;
    streetName?: string | null;
    zipcode?: string | null;
}

export enum EventTranslationCode {
    ShipmentRegistered = 'ShipmentRegistered',
    ShipmentDispatched = 'ShipmentDispatched',
    ShipmentAtTerminal = 'ShipmentAtTerminal',
    ShipmentInTransitToDestination = 'ShipmentInTransitToDestination',
    DeliveryAttemptFailed = 'DeliveryAttemptFailed',
    ShipmentReadyForPickup = 'ShipmentReadyForPickup',
    ReceiverNotifiedForPickup = 'ReceiverNotifiedForPickup',
    ReceiverPickupReminder = 'ReceiverPickupReminder',
    ShipmentDelivered = 'ShipmentDelivered',
    ShipmentDelayed = 'ShipmentDelayed',
    ShipmentCancelled = 'ShipmentCancelled',
    ShipmentReturned = 'ShipmentReturned',
    ShipmentStatusOther = 'ShipmentStatusOther',
    ShipmentStatusUnknown = 'ShipmentStatusUnknown',
}

export interface Item {
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    id: number;
    shippingOptions?: ShippingDtoShippingOption[] | null;
    title?: string | null;
    /** @format date-time */
    transactionDate: string;
    /** @format int32 */
    transactionId: number;
}

export interface Package {
    /** @format double */
    height: number;
    /** @format double */
    length: number;
    /** @format double */
    weight: number;
    /** @format double */
    width: number;
}

export interface ShippingDtoShippingDetails {
    agentAddress?: ShippingDtoAddress | null;
    agentId?: string | null;
    agentName?: string | null;
    buyerAddress?: ShippingDtoAddress | null;
    buyerName?: string | null;
    package?: Package | null;
    /** @format uuid */
    purchaseOrderId: string;
    shipmentId?: string | null;
    /** @format int32 */
    shippingProductId: number;
    shippingProvider?: string | null;
    transactionIds?: number[] | null;
}

export interface ShippingDtoShippingOption {
    /** @format int32 */
    cost: number;
    isFreeShipping: boolean;
    isTakeaway: boolean;
    selectedByBuyer: boolean;
    type?: string | null;
}

export interface TraceEvent {
    /** @format date-time */
    date: string;
    description?: string | null;
    eventTranslationCode?: EventTranslationCode | null;
    location?: string | null;
    type?: string | null;
}

export interface TraceInfo {
    /** @format double */
    actualWeight?: number | null;
    agent?: Agent | null;
    error: boolean;
    errorMessage?: string | null;
    events?: TraceEvent[] | null;
    pickupNumber?: string | null;
}

export interface ShippingAddressLabelApiResponse {
    pdf?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface ShippingAddressLabelCombinedApiResponse {
    pdf?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface ShippingDetailsApiResponse {
    items?: Item[] | null;
    responseStatus?: ResponseStatus | null;
    shippingDetails?: ShippingDtoShippingDetails | null;
}

export interface TraceInfoApiResponse {
    responseStatus?: ResponseStatus | null;
    traceInfo?: TraceInfo | null;
}

export interface UpdateShippingPriceApiRequest {
    /** @format int32 */
    price: number;
    /** @format uuid */
    purchaseOrderId: string;
    /** @format int32 */
    shippingProductId?: number | null;
    shippingProvider?: string | null;
    sizeCategory?: string | null;
}

export interface UpdateShippingPriceApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UnbookedShipmentsRequest {
    request?: GetUnbookedShipmentsApiRequest;
}

export interface UnsoldCreateParams {
    request?: SellerUnsoldApiRequest;
}

export interface UpdateShippingPriceCreateParams {
    request?: UpdateShippingPriceApiRequest;
}

export interface WalletRequest {
    eventTypes?: string[];
    /** @format date-time */
    startDate?: string;
    /** @format date-time */
    endDate?: string;
    /** @format int32 */
    toSequenceNumber?: number;
    /** @format int32 */
    pageSize?: number;
}
